<template>
  <div>
    <app-form
      v-bind:parentObject="{
        data: this.formData,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }"
      v-on:input="formData = $event"
      v-on:finalize="finalizeHandler"
    />

    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>

import PayrollFinalizationForm from "../../../components/payroll/payrollfinalization/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  components: {
    "app-form": PayrollFinalizationForm,
    "app-error": ErrorDialog,
  },

  data() {
    return {
      pageTitle:this.$t('finizepayroll.payrollfinalization'),
      pageTitleValue: "",
      formData: {
        payoutcode: null,
        payoutdesc: null,
        pyyear: null,
        pymonth: null,
        startdate: null,
        enddate: null,
        payrolltypeid: null,
        pycrcyid: null,
        grouppbid: null,
        exchrateid: null,
        salfreqid: null,
        payeelistcode: null,
        pystatuscode: null,
        allowinput: null,
        ssrel: null,
        stamp: 0,
        userid: this.$store.getters.userId,
      },
      errMsg: "",
      isErr: false,
      editMode: false,
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    finalizeHandler() {
      if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
        return false;
      }
      const vm = this;
      vm.formData.pystatuscode = 99;

      this.$store.dispatch('put', {url: "/payoutctrl/" + this.formData.id, payload: this.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "payrollfinalizationlist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },
  },
};
</script>